import { proxy } from './proxy';
export default class Emitter {
    constructor() {
        this.listeners = {};
    }
    on(event, listener) {
        this.listeners[event] = this.listeners[event] || [];
        this.listeners[event].push(listener);
        return {
            remove: () => {
                this.off(event, listener);
            },
        };
    }
    emit(event, ...args) {
        const listener = this.listeners[event];
        if (listener) {
            listener.forEach((listener) => listener(...args));
        }
    }
    off(event, listener) {
        const listeners = this.listeners[event];
        if (listeners) {
            listeners.splice(listeners.indexOf(listener), 1);
        }
    }
    get call() {
        return proxy((property) => {
            return (...args) => {
                this.emit(property, ...args);
            };
        });
    }
    get listen() {
        return proxy((property) => {
            return (listener) => {
                this.on(property, listener);
                return () => {
                    this.off(property, listener);
                };
            };
        });
    }
}
//# sourceMappingURL=emitter.js.map